import { useState } from 'react';

import LeadForm from './LeadForm';
import PageMeta from './PageMeta';
import { RedesignFooter, RedesignHeader, RedesignPage, SiteLink } from './RedesignShell';

const taskBullets = [
  'привлечение новых клиентов из поисковых систем',
  'повышение узнаваемости бренда компании',
  'автоматизация обработки заявок и данных',
  'презентация услуг и преимуществ бизнеса',
  'интеграция с CRM и аналитикой',
];

const serviceTypes = [
  {
    title: 'Сайт оказания услуг',
    paragraphs: ['Классический сайт с описанием услуг, ценами и формами заявки. Подходит для малого и среднего бизнеса.'],
  },
  {
    title: 'Корпоративный сайт услуг',
    paragraphs: [
      'Корпоративный сайт включает информацию о компании, кейсы, отзывы клиентов и блог. Помогает формировать доверие и репутацию.',
    ],
  },
  {
    title: 'Сайт услуг с каталогом',
    paragraphs: ['Сайт с каталогом позволяет структурировать услуги, добавлять фильтры и категории. Удобен для пользователей.'],
  },
  {
    title: 'Сайт услуг с интеграцией CRM',
    paragraphs: [
      'Интеграция с CRM-системами позволяет автоматически обрабатывать заявки, управлять клиентами и повышать эффективность работы.',
    ],
  },
  {
    title: 'Персонализированные сайты услуг',
    paragraphs: ['Индивидуальные проекты с уникальным дизайном и функционалом. Подходят для сложных задач и крупных компаний.'],
  },
];

const includedSteps = [
  {
    title: 'Аналитика и проектирование',
    paragraphs: ['Проводится анализ бизнеса, конкурентов и целевой аудитории. Формируется структура сайта и техническое задание.'],
  },
  {
    title: 'UX/UI дизайн сайта услуг',
    paragraphs: ['Создается удобный интерфейс и современный дизайн. Прорабатывается логика взаимодействия пользователей с сайтом.'],
  },
  {
    title: 'Разработка и программирование',
    paragraphs: ['Программисты реализуют функционал сайта, подключают модули и интеграции. Обеспечивается стабильная работа ресурса.'],
  },
  {
    title: 'SEO-оптимизация сайта услуг',
    paragraphs: ['Сайт оптимизируется под поисковые системы. Настраиваются мета-теги, структура и контент.'],
  },
  {
    title: 'Тестирование и запуск',
    paragraphs: ['Перед запуском проводится тестирование. Проверяется скорость загрузки, корректность работы и безопасность.'],
  },
];

const cmsItems = [
  {
    title: 'Создание сайта услуг на WordPress',
    paragraphs: ['Популярная платформа с гибкими настройками. Подходит для большинства проектов.'],
  },
  {
    title: 'Создание сайта услуг на Bitrix',
    paragraphs: ['Надежная CMS для корпоративных сайтов. Поддерживает интеграции с 1С и CRM.'],
  },
  {
    title: 'Индивидуальная CMS для сайта услуг',
    paragraphs: ['Разработка собственной системы управления под задачи бизнеса. Максимальная гибкость и контроль.'],
  },
];

const technologies = [
  {
    title: 'Frontend',
    paragraphs: ['Отвечает за внешний вид сайта. Используются современные фреймворки и адаптивная верстка.'],
  },
  {
    title: 'Backend',
    paragraphs: ['Обеспечивает работу логики и обработку данных. Настраиваются серверные процессы и базы данных.'],
  },
  {
    title: 'CMS и фреймворки',
    paragraphs: ['Используются проверенные решения для разработки и масштабирования проекта.'],
  },
  {
    title: 'Интеграции и API',
    paragraphs: ['Подключаются CRM, аналитика, платежные системы и другие сервисы.'],
  },
];

const processSteps = [
  {
    title: 'Анализ и бриф',
    paragraphs: ['Сбор информации о проекте. Определение целей и задач.'],
  },
  {
    title: 'Проектирование структуры сайта услуг',
    paragraphs: ['Создание логичной структуры страниц и блоков.'],
  },
  {
    title: 'Дизайн сайта услуг',
    paragraphs: ['Разработка уникального дизайна с учетом бренда и аудитории.'],
  },
  {
    title: 'Разработка сайта услуг',
    paragraphs: ['Программирование, настройка функционала и интеграций.'],
  },
  {
    title: 'Запуск и оптимизация',
    paragraphs: ['Запуск сайта и дальнейшая оптимизация под SEO и конверсии.'],
  },
];

const approachItems = [
  {
    title: 'Agile / Scrum',
    paragraphs: ['Гибкий подход позволяет быстро вносить изменения и улучшения.'],
  },
  {
    title: 'Прозрачные этапы',
    paragraphs: ['Клиент контролирует каждый этап разработки проекта.'],
  },
  {
    title: 'Фокус на конверсии',
    paragraphs: ['Сайт создается как инструмент продаж и привлечения клиентов.'],
  },
];

const formats = [
  {
    title: 'Проектная разработка',
    paragraphs: ['Полный цикл создания сайта под ключ.'],
  },
  {
    title: 'Выделенная команда',
    paragraphs: ['Команда специалистов работает над проектом на постоянной основе.'],
  },
  {
    title: 'Почасовая разработка',
    paragraphs: ['Гибкий формат для доработок и улучшений сайта.'],
  },
];

const deliverables = [
  {
    title: 'Готовый сайт услуг под ключ',
    paragraphs: ['Полностью настроенный и готовый к работе ресурс.'],
  },
  {
    title: 'SEO-оптимизированный сайт',
    paragraphs: ['Сайт подготовлен для продвижения в поисковых системах.'],
  },
  {
    title: 'Удобную админ-панель',
    paragraphs: ['Простое управление контентом и данными.'],
  },
  {
    title: 'Масштабируемый сайт',
    paragraphs: ['Возможность развития и добавления нового функционала.'],
  },
];

const supportItems = [
  {
    title: 'Техническая поддержка',
    paragraphs: ['Оперативное устранение ошибок и обновления системы.'],
  },
  {
    title: 'SLA и гарантии',
    paragraphs: ['Фиксированные сроки реакции и выполнения задач.'],
  },
  {
    title: 'Доработки и развитие',
    paragraphs: ['Добавление новых функций и улучшение сайта.'],
  },
  {
    title: 'SEO и продвижение',
    paragraphs: ['Продвижение сайта в поисковых системах и увеличение трафика.'],
  },
];

const priceFactors = ['тип сайта и структура', 'дизайн и уникальность', 'интеграции и функционал', 'сроки разработки'];

const relatedServices = [
  { href: 'https://fatalitystudio.ru/services/websites/corporate/', title: 'Разработка корпоративного сайта' },
  { href: 'https://fatalitystudio.ru/services/websites/landing/', title: 'Разработка лендинга' },
  { href: 'https://fatalitystudio.ru/services/seo/', title: 'SEO продвижение' },
  { href: 'https://fatalitystudio.ru/services/websites/redesign-support/', title: 'Техническая поддержка сайта' },
];

const faqItems = [
  {
    question: 'Сколько стоит создать сайт услуг?',
    answer: 'Цена зависит от сложности проекта, дизайна и функционала. Точный расчет делается после анализа задач.',
  },
  {
    question: 'Сроки разработки сайта услуг?',
    answer: 'В среднем от 2 до 8 недель. Зависит от объема работ.',
  },
  {
    question: 'Что нужно для старта?',
    answer: 'Достаточно описания бизнеса, услуг и целей проекта.',
  },
  {
    question: 'Можно ли заказать сайт услуг под ключ?',
    answer: 'Да, разработка выполняется полностью — от идеи до запуска.',
  },
  {
    question: 'Можно ли интегрировать сайт с CRM?',
    answer: 'Да, возможна интеграция с любыми CRM и сервисами аналитики.',
  },
];

const relatedCardTitleStyle = {
  color: 'var(--ink)',
  fontFamily: "'Space Grotesk', sans-serif",
  fontSize: '24px',
  fontWeight: 600,
  letterSpacing: '-0.025em',
  lineHeight: 1.16,
};

function Paragraphs({ paragraphs }) {
  return paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>);
}

function BulletList({ items }) {
  return (
    <ul className="source-list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

function SectionHeader({ eyebrow, title, description, dark = false }) {
  return (
    <div className={`sec-head${dark ? ' ink-head' : ''}`}>
      <div>
        <div className={`eyebrow${dark ? ' cyan' : ''}`}>{eyebrow}</div>
        <h2>{title}</h2>
      </div>
      {description && <p className="sub">{description}</p>}
    </div>
  );
}

function Cards({ items, actionLabel, iconSet }) {
  return (
    <div className="compact-card-grid">
      {items.map((item, index) => (
        <div className={`compact-card${actionLabel ? ' interactive-card' : ''}`} key={item.title}>
          {iconSet ? (
            <span className={`service-source-icon ${iconSet} ${iconSet}-${index + 1}`} aria-hidden="true" />
          ) : (
            <div className="compact-num">{String(index + 1).padStart(2, '0')}</div>
          )}
          <h3>{item.title}</h3>
          <Paragraphs paragraphs={item.paragraphs} />
          {actionLabel && (
            <SiteLink href="#service-business-lead" className="link-flat">
              {actionLabel}
            </SiteLink>
          )}
        </div>
      ))}
    </div>
  );
}

function ProcessRail({ items }) {
  return (
    <div className="process-rail process-rail-five">
      {items.map((item, index) => (
        <div className="process-step" key={item.title}>
          <div className="process-num">{String(index + 1).padStart(2, '0')}</div>
          <h3>{item.title}</h3>
          <Paragraphs paragraphs={item.paragraphs} />
        </div>
      ))}
    </div>
  );
}

function ServiceBusinessPage() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <RedesignPage>
      <PageMeta
        title="Разработка сайта услуг под ключ — создать сайт услуг для бизнеса, цены и заказ"
        description="Разработка сайта услуг под ключ для бизнеса. Создаем сайты услуг любой сложности: корпоративные, лендинги, с CRM и SEO-оптимизацией. Узнайте стоимость, сроки и закажите сайт для привлечения клиентов онлайн..Системный подход, множество кейсов и команда профессионалов.Ведем более 30 проектов на ежедневной тех.поддержке. Рассчитайте стоимость в веб-студии fatalitystudio.ru или по телефону +7 (925) 653-04-54 !"
      />
      <RedesignHeader />

      <section className="ink service-hero">
        <div
          className="glow"
          style={{ right: '-360px', top: '-340px', width: '980px', height: '980px', opacity: 0.1 }}
        />
        <div className="container service-hero-grid">
          <div>
            <div className="eyebrow cyan">— сайт услуг</div>
            <h1>Создание сайта услуг под ключ</h1>
            <p className="hero-sub">
              Разработка сайта услуг — это эффективный инструмент для роста бизнеса в интернете. Такой сайт помогает
              привлекать клиентов, повышать доверие и увеличивать продажи. Команда специалистов создает сайты под ключ с
              учетом задач бизнеса, целевой аудитории и требований поисковых систем.
            </p>
            <div className="hero-ctas">
              <SiteLink href="#service-business-lead" className="btn btn-primary">
                Разработка сайта услуг - в Fatality
              </SiteLink>
              <SiteLink href="/services/websites/corporate/" className="btn btn-ghost-dark">
                Разработка корпоративного сайта
              </SiteLink>
            </div>
          </div>
          <div className="service-hero-panel" aria-label="Какие задачи решает сайт услуг">
            {taskBullets.map((item, index) => (
              <div className="panel-line" key={item}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                <b>{item}</b>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— бизнес"
            title="Создание сайта услуг для бизнеса"
            description="Создание сайта услуг необходимо компаниям, которые хотят стабильно получать заявки через интернет. Сайт становится основной площадкой для продвижения, коммуникации и продаж."
          />
          <div className="split-proof">
            <div>
              <p>
                Разработка сайта для бизнеса включает проектирование структуры, дизайн, программирование и
                SEO-оптимизацию.
              </p>
            </div>
            <div>
              <p>В результате клиент получает готовый инструмент для привлечения трафика и обработки заявок.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— задачи"
            title="Какие задачи решает сайт услуг"
            description="Сайт услуг решает ключевые задачи бизнеса и помогает масштабировать продажи."
          />
          <div className="split-proof">
            <div>
              <p>Основные задачи:</p>
              <BulletList items={taskBullets} />
              <p>Такой ресурс работает 24/7 и становится частью маркетинговой стратегии.</p>
              <SiteLink href="#service-business-lead" className="btn btn-primary section-action">
                Разработка сайта услуг - в Fatality
              </SiteLink>
            </div>
            <div className="check-grid">
              {taskBullets.map((item) => (
                <div className="check-item" key={item}>
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— типы"
            title="Какие сайты услуг мы создаем"
            description="Разработка сайтов услуг выполняется под разные задачи и направления бизнеса."
            dark
          />
          <Cards items={serviceTypes} actionLabel="Узнать стоимость" />
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— состав работ"
            title="Что входит в создание сайта услуг"
            description="Разработка сайта — это комплексный процесс, включающий несколько этапов."
          />
          <ProcessRail items={includedSteps} />
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— cms"
            title="CMS для создания сайта услуг"
            description="Выбор CMS влияет на удобство управления и развитие проекта."
          />
          <Cards items={cmsItems} />
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— технологии"
            title="Технологии создания сайтов услуг"
            description="Современные технологии обеспечивают высокую скорость и стабильность сайта."
            dark
          />
          <div className="tech-tiles">
            {technologies.map((item, index) => (
              <div className="tech-tile" key={item.title}>
                <div className="why-n">{String(index + 1).padStart(2, '0')}</div>
                <h3>{item.title}</h3>
                <Paragraphs paragraphs={item.paragraphs} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— процесс"
            title="Как проходит создание сайта услуг"
            description="Процесс разработки прозрачен и делится на этапы."
          />
          <ProcessRail items={processSteps} />
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— подход"
            title="Подход к созданию сайтов услуг"
            description="Команда работает по современным методологиям разработки."
          />
          <Cards items={approachItems} />
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader eyebrow="— форматы" title="Форматы сотрудничества" description="Доступны разные форматы работы с клиентами." dark />
          <Cards items={formats} actionLabel="Выбрать этот формат" iconSet="service-format-icon" />
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            eyebrow="— итог"
            title="Что вы получаете в итоге"
            description="После разработки клиент получает готовый продукт."
          />
          <Cards items={deliverables} iconSet="service-outcome-icon" />
          <SiteLink href="#service-business-lead" className="btn btn-primary section-action">
            Заказать разработку сайта услуг
          </SiteLink>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— поддержка"
            title="Поддержка и развитие сайта услуг"
            description="После запуска сайт требует сопровождения."
          />
          <Cards items={supportItems} />
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            eyebrow="— стоимость"
            title="Стоимость создания сайта услуг"
            description="Цена разработки зависит от задач проекта."
          />
          <div className="pricing-layout">
            <div className="price-list">
              <h3 className="pricing-subhead">Сколько стоит сайт услуг</h3>
              <p className="pricing-copy">Стоимость определяется объемом работ и сложностью функционала.</p>
              <h3 className="pricing-subhead">От чего зависит цена</h3>
              <div style={{ padding: '0 36px 30px', borderBottom: '1px solid var(--line-light)' }}>
                <p>Основные факторы:</p>
                <BulletList items={priceFactors} />
              </div>
              <h3 className="pricing-subhead">Сайт услуг — цены и тарифы</h3>
              <p className="pricing-copy">
                Предлагаются разные тарифы под задачи бизнеса — от базовых до комплексных решений.
              </p>
            </div>
            <div className="price-note">
              <h3>Получить расчет стоимости</h3>
              <p>
                Для расчета стоимости достаточно оставить заявку и получить коммерческое предложение индивидуально под
                Ваши услуги и запрос.
              </p>
              {/* TODO(brand-redesign): add the manager trust block after the source photo and manager name are provided. */}
              <LeadForm
                formId="service-business-calc-form"
                idPrefix="service-business-calc"
                contactLabel="Телефон или E-mail"
                contactType="text"
                contactPlaceholder="+7 или почта"
                showTelegram={false}
                showCompany={false}
                typeLabel="Тип сайта"
                typeOptions={serviceTypes.map(({ title }) => title)}
                submitLabel="Получить расчёт бесплатно"
                taskPlaceholder="Комментарий"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader eyebrow="— рядом" title="Похожие услуги" description="Дополнительно доступны:" />
          <div className="related-grid">
            {relatedServices.map((item) => (
              <SiteLink href={item.href} className="related-card" key={item.title}>
                <div style={relatedCardTitleStyle}>{item.title}</div>
              </SiteLink>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <div className="faq-grid">
            <div>
              <div className="eyebrow">— faq</div>
              <h2 className="standalone-h2">Ответы на частые вопросы</h2>
            </div>
            <div className="faq-list">
              {faqItems.map((item, index) => {
                const isOpen = openFaq === index;
                return (
                  <div className={`faq-item${isOpen ? ' open' : ''}`} key={item.question}>
                    <div className="faq-q">
                      <h3 className="faq-question-heading">
                        <button
                          aria-controls={`service-business-faq-answer-${index}`}
                          aria-expanded={isOpen}
                          className="faq-question-button"
                          type="button"
                          onClick={() => setOpenFaq(isOpen ? -1 : index)}
                        >
                          {item.question}
                        </button>
                      </h3>
                      <span className="faq-toggle" aria-hidden="true">+</span>
                    </div>
                    <div className="faq-a" id={`service-business-faq-answer-${index}`}>
                      <div className="faq-a-inner">
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="ink lead" id="service-business-lead">
        <div
          className="glow"
          style={{ left: '-300px', top: '-200px', width: '700px', height: '700px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="lead-grid">
            <div className="lead-side">
              <div className="eyebrow cyan">— заявка</div>
              <h2 className="lead-heading">Заказать создание сайта услуг</h2>
              <p className="lead-text">
                Чтобы заказать разработку сайта услуг, достаточно оставить заявку. Специалисты проведут консультацию,
                подготовят предложение и запустят проект в работу.
              </p>
              <p className="lead-text">
                P.S. Мы сами не любим холодные продажи и “впаривание услуг”, поэтому напишите в кратком описании, как Вам
                удобнее обсудить проект. 😀
              </p>
              <p className="lead-text">
                Специалисты свяжутся в удобном для Вас формате и предложат лучшее для Вас решение по цене, срокам и
                функционалу.
              </p>
            </div>
            <LeadForm
              formId="service-business-lead-form"
              idPrefix="service-business"
              contactLabel="Телефон или E-mail"
              contactType="text"
              contactPlaceholder="+7 или почта"
              showTelegram={false}
              showCompany={false}
              typeLabel="Тип сайта"
              typeOptions={serviceTypes.map(({ title }) => title)}
              submitLabel="Получить расчёт бесплатно"
              taskPlaceholder="Напишите в кратком описании, как Вам удобнее обсудить проект"
            />
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default ServiceBusinessPage;
